import { call, put, fork, select, take, takeEvery } from 'redux-saga/effects';
import { api }                from 'apps/api'
import { FSA }                from 'flux-standard-action';
import { deepmerge }          from 'utilities/merge';
import { getDataByDot }       from 'utilities/hash';
import isEmpty                from 'validator/lib/isEmpty';
import isPostalCode           from 'utilities/validators/isPostalCode';
import isHiragana             from 'utilities/validators/isHiragana';
import isEmail                from 'validator/lib/isEmail';
import isRegex                from 'utilities/validators/isRegex';
/**
 * バリデーションを実行するクラスのスーパークラス
 */
export class BaseValidator {
  /**
   * scope: initメソッドの引数 action.payload の中に入れてセットする
   * 特定の要素のみにバリデーションしたい場合↓
   * action.payload.targetに"all"を渡す。
   * すべての要素にバリデーションしたい場合↓
   * action.payload.targetに部分(ex. "email")を渡す。
   */
  protected target:     string;
  protected callback:   Function;
  public    newVal:     any;
  protected messages:   any;
  protected baseScope:  string;
  protected properties: Array<string>;
  public init(action: FSA<any, any>){
    if(action.payload.baseScope){ this.baseScope = action.payload.baseScope; }
    this.target    = action.payload.target;
    this.callback  = action.payload.callback;
    let data = getDataByDot(App.store.getState().data, this.baseScope);
    this.messages = data.messages;
    this.newVal = deepmerge({}, data);
    if(this.target === 'all'){
      this.newVal.error = false;
      for(var i=0; i < this.properties.length; i++){
        let property = this.properties[i];
        this.initProperty(property);
      }
    } else {
      this.initProperty(this.target);
    }
    return this;
  }
  protected initProperty(target: string){
    let property = this.propertyOf(target);
    delete property['errors'];
    property.errors = false;
  }
  validEmail(){
    let email   = this.newVal.inputs.email.value;
    let isValid = isEmail(email);
    let message;
    if(!isValid){
      this.newVal.error = true;
      message = this.messages.user.email.email;
    }
    this.addMessage(this.newVal.inputs.email, message);
    return this.newVal
  }
  uniqueEmail = function*(){
    let email   = this.newVal.inputs.email;
    let user_id = this.newVal.user_id;
    let at      = this.newVal.inputs.email.authenticity_token;
    let callParams = { email: email.value, user_id: user_id, at: at };
    let { data, error } = yield call(api.validUniqueEmail, callParams);
    let message;
    if(data && !data.isValid){
      this.newVal.error = true;
      message = this.messages.user.email.unique;
    } else if(error){
      this.newVal.error = error;
      message = this.messages.commons.error_500;
    }
    this.addMessage(this.newVal.inputs.email, message);
    return this.newVal
  }
  protected addMessage(property, message){
    if(!message){ return false; }
    if(!property.errors){ property.errors = []; }
    if(this.hasSameMessage(property, message)){ return false; }
    property.errors.push(message);
  }
  protected hasSameMessage(property, message){
    for(let i=0;i<property.errors.length; i++){
      if(property.errors[i] == message){
        return true;
      }
    }
    return false;
  }
  public clearMessage(scope){
    scope.errors = [];
  }
  public propertyOf(target){
    if(target.indexOf('.') < 0){
      if(!this.newVal.inputs[target]){
        console.error('inputs has no property: ' + target);
        return;
      }
      return this.newVal.inputs[target]
    } else { //２階層の場合
      let props = target.split('.');
      if(!this.newVal.inputs[props[0]]){
        console.error('inputs has no property: ' + props[0]);
        return;
      }
      if(!this.newVal.inputs[props[0]][props[1]]){
        console.error('inputs has no property: ' + props[1]);
        return;
      }
      return this.newVal.inputs[props[0]][props[1]];
    }
  }
  public targetIs(target){
    if(this.target === 'all'){
      // if(!this.newVal.inputs[target]){ return false; }
      return true;
    }
    if(this.target === target) {return true;}
    return false;
  }
  public done(){
    if(this.callback){ this.callback(this); }
  }
  public hasErrorOf(target){
    let property = this.propertyOf(target);
    if(!property.errors){ return false; }
    if(!property.errors.length){ return false; }
    return property.errors.length >= 1
  }
  // validators utilities
  public validAndAddMessage(target, message, validFunction, reverse = false){
    this.initProperty(target);
    let { property, value, isValid } = this.prepareValidation(validFunction, target, reverse);
    this.addMessageIfNotValid(isValid, property, message);
    return { property, value, isValid };
  }
  public prepareValidation(validFunction, target, reverse = false){
    let property = this.propertyOf(target);
    let value = property.value;
    if(value == null){value = '';}
    let isValid = validFunction(value.toString());
    if(reverse) { isValid = !isValid };
    return { property, value, isValid };
  }
  public addMessageIfNotValid(isValid, property, message){
    if(isValid){ return; }
    this.newVal.error = true;
    this.addMessage(property, message);
  }
  // validators
  public require(target, message){
    let { property, value, isValid } = this.validAndAddMessage(target, message, isEmpty, true);
    return isValid;
  }
  public isPostalCode(target, message){
    let { property, value, isValid } = this.validAndAddMessage(target, message, isPostalCode);
    if(isValid){ property.value = value; }
    return isValid;
  }
  public isHiragana(target, message){
    let { property, value, isValid } = this.validAndAddMessage(target, message, isHiragana);
    return isValid;
  }
  public isRegex(target, message, regex){
    let validFunction = (value) => { return isRegex(value, regex); }
    let { property, value, isValid } = this.validAndAddMessage(target, message, validFunction);
    return isValid;
  }
}
